import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Thumbnail, Checkbox } from '@shopify/polaris'

import Text from 'components/common/Text'

const Container = styled.div`
  width: 100%;
  display: flex;
  height: 4em;
  align-items: center;
  justify-content:  flex-start;
  cursor: pointer;

  & .Polaris-Thumbnail--sizeSmall {
    width: 3em;
    height: 3em;
  }

`
const TitleContainer = styled.div`
  margin-left: 1em;
`
const CheckboxContainer = styled.div`
  width: 4em;
  display: flex;
  justify-content: center;
  cursor: pointer;
`

class ProductRow extends Component {

  constructor (props) {
    super(props)
    console.log('ProductRow constructor', props)
  }

  onChange = (isChecked) => {
    const { onSelect, onRemove, productId } = this.props
    if (isChecked) {
      onSelect(productId)
    } else {
      onRemove(productId)
    }
  }

  render () {
    const { title, image, isChecked } = this.props
    console.log('ProductRow render', title, image, isChecked)
    return (
      <Container onClick={() => this.onChange(!isChecked)}>
        <CheckboxContainer>
          <Checkbox
            checked={isChecked}
            onChange={this.onChange}
          />
        </CheckboxContainer>
        <Thumbnail source={image} size='small' />
        <TitleContainer>
          <Text>{title}</Text>
        </TitleContainer>
      </Container>
    )
  }
}

ProductRow.propTypes = {
  productId: PropTypes.number, //eslint-disable-line
  image: PropTypes.string,
  title: PropTypes.string,
  isChecked: PropTypes.bool,
  onSelect: PropTypes.func,
  onRemove: PropTypes.func
}

export default ProductRow



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/addCollection/ProductRow.js